export default __webpack_public_path__ + "static/step_08-4eb5953fb6a88119dedb56f2f7e0b404.png";